// stores/superAdminDashboardStore.ts

import { create } from 'zustand';
import apiClient from '../apiSetup/axiosInterceptor';

// =============== Types ===============

interface SuperAdminUser {
  user_id: string;
  name: string | null;
  email: string;
  role: string;
  created_at: string | null;
}

interface Institute {
  institute_id: string;
  name: string;
  address: string | null;
  contact_no: string | null;
  email: string | null;
  created_at: string | null;
}

export interface DashboardData {
  user: SuperAdminUser;
  institutes: Institute[];
  // Extend this interface when you add more sections (e.g., branches, stats)
}

interface ApiResponse {
  success: boolean;
  data: DashboardData;
}

interface SuperAdminDashboardState {
  data: DashboardData | null;
  loading: boolean;
  error: string | null;
  fetchDashboardData: () => Promise<void>;
  clearError: () => void;
}

// =============== Store ===============

export const useSuperAdminDashboardStore = create<SuperAdminDashboardState>((set) => ({
  data: null,
  loading: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDashboardData: async () => {
    set({ loading: true, error: null });
    try {
      const response = await apiClient.get<ApiResponse>('/v1/dashboard/general-data');
      // Extract nested data: response.data → { success, data: DashboardData }
      console.log('data test',response.data)
      set({ data: response.data.data, loading: false });
    } catch (err: any) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load dashboard data';
      set({ error: message, loading: false });
    }
  },
}));